import React from 'react'
import Modal from '@jarvis.oddle/core/components/Modal'
import { PromotionItemForm } from '@jarvis.oddle/core/molecules/PromotionModal'
import { togglePromotionAction } from 'src/redux/order/action'
import useAppDispatch from 'src/hooks/useAppDispatcher'
import { makeControlledModal } from 'src/decorators/ModalController'
import { useAppContext } from 'src/containers/AppContext'

const CheckoutPromotionItemModal = ({
  modal,
  goToPreviousModal,
  promotion = {} as SelectedPromotion
}: {
  modal: {
    show: boolean
    onClose: () => void
    onClosed: () => void
  }
  goToPreviousModal: () => void
  promotion: SelectedPromotion
}) => {
  const { formatMoney } = useAppContext()
  const dispatch = useAppDispatch()
  const applyPromotion = (values) => {
    const parsedPromotion = {
      ...promotion,
      selectedItems: (promotion.promotionItems || [])
        .filter((promotionItem) => values[promotionItem.id])
        .map((promotionItem) => ({
          ...promotionItem,
          quantity: values[promotionItem.id]
        }))
    }
    dispatch(togglePromotionAction({ promotion: parsedPromotion }))
    goToPreviousModal()
  }

  return (
    <Modal {...modal} onClose={goToPreviousModal} slideInAnimation='bottom'>
      <PromotionItemForm
        onPromotionItemSubmit={applyPromotion}
        promotionItems={promotion.promotionItems}
        promotionQuantity={promotion.quantity}
        onPrevButtonClick={goToPreviousModal}
        onCloseButtonClick={goToPreviousModal}
        formatMoney={formatMoney}
      />
    </Modal>
  )
}

export default makeControlledModal(
  CheckoutPromotionItemModal,
  'CheckoutPromotionItemModal'
)
